/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .input-group.bottom[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}[_nghost-%COMP%]   .input-group.bottom[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-bottom:1rem}[_nghost-%COMP%]   .input-group[_ngcontent-%COMP%]   ng-select[_ngcontent-%COMP%]{max-width:300px}"];
export { styles as styles };
